<!-- Breadcrumb -->
<div class="pag-container">

  <app-campaign-3-breadcrumb #breadcrumbComponent *ngIf="showBreadCrumb" [arrayBreadcrumbs]="breadcrumbs"
    (onClickBreadcrumb)="breadcrumbClicked($event)" homeLink=""></app-campaign-3-breadcrumb>

  <!-- Bottoni gialli di lista azioni e creazione -->
  <div class="ui-g-12 d-flex justify-content-center">

    <div class="ui-g-7">
    </div>
    <div class="ui-g-5 footer-btn-container">

      <button data-testid="createNewCampaign" class="btn-page-act" (click)="onOpenCreation()">
        <i class="pi pi-plus"></i> <span>{{ 'baskets.insert_new_basket' | translate }}</span>
      </button>
    </div>
  </div>

  <div class="ui-g-12 prova">

    <!-- Attenzione il campo dei filtri della statu description manda in pasto il flag state quando in realtà dsovrebbe andarci l'idStatus (sempre nullo) -->
    <app-campaign-3-kontable *ngIf="readyTable" #basketsListKontableComponent [columns]="[
     {
    field: 'id',
    title: 'baskets.id',
    filterType: textFilter,
    bodyTemplate: idTemplate
  },
  {
    field: 'code',
    title: 'baskets.code',
    filterType: textFilter,
    bodyTemplate: codeTemplate
  },
  {
    field: 'name',
    title: 'baskets.name',
    filterType: textFilter
  },
  {
    field: 'description',
    title: 'baskets.description',
    filterType: textFilter
  },
  {
    field: 'basket_detail_count',
    title: 'baskets.basket_detail_count',
    filterType: numberFilter,
    bodyTemplate: basketDetailCountTemplate
  },
  {
    field: 'active_promo_count',
    title: 'baskets.active_promo_count',
    filterType: numberFilter,
    bodyTemplate: activePromoCountTemplate
  },
  {
    field: 'active_action_count',
    title: 'baskets.active_action_count',
    filterType: numberFilter,
    bodyTemplate: activeActionCountTemplate
  },
  {
    field: 'basket_last_update',
    title: 'baskets.basket_last_update',
    type: 'date',
    filterType: dateFilter,
    bodyTemplate: lastUpdateDateTemplate
  },
    {
          field: 'flg_enabled',
          title: 'baskets.flg_enabled',
          filterType: selectFilter,
          filterOptions: { values: actionStatusList },
          bodyTemplate: statusTemplate
        }


  
  ]" [service]="basketService" [paginationType]="paginationType" [additionalRowCommands]="actions"
      [expandTable]="false" [fetchActionListAsap]="false" [subjectToLoad]="pageSubject" [filterBySingleColumn]="false"
      [showRecoverButton]="false" [showInfoButton]="false" [showAddButton]="false" [showDeleteButton]="false"
      [showDetailsButton]="false" [showEditButton]="false" [showGlobalFilter]="true">


      <!-- STATUS -->
      <ng-template #statusTemplate let-row>
        <span class="center-number">
          {{ translateState(row.flg_state) }}
        </span>
      </ng-template>

      <!-- ID -->
      <ng-template #idTemplate let-row>
        <span class="center-number">
          {{ row.id }}
        </span>
      </ng-template>

      <!-- CODE -->
      <ng-template #codeTemplate let-row>
        <span class="center-number">
          {{ row.code }}
        </span>
      </ng-template>

      <!-- BASKET DETAIL COUNT -->
      <ng-template #basketDetailCountTemplate let-row>
        <span class="center-number">
          {{ row.basket_detail_count }}
        </span>
      </ng-template>

      <!-- ACTIVE PROMO COUNT -->
      <ng-template #activePromoCountTemplate let-row>
        <span class="center-number">
          {{ row.active_promo_count }}
        </span>
      </ng-template>

      <!-- ACTIVE ACTION COUNT -->
      <ng-template #activeActionCountTemplate let-row>
        <span class="center-number">
          {{ row.active_action_count }}
        </span>
      </ng-template>

      <!-- LAST UPDATE DATE -->
      <ng-template #lastUpdateDateTemplate let-row>
        <span class="center-number"> {{
          row.basket_last_update |
          date:srvCalendar.pcalendarTranslate.dateFormatFilter
          }}</span>
      </ng-template>


      <ng-template #actions let-row>

        <div class="d-flex justify-content-center">
          <button data-testid-generic="editDistribution" [attr.data-testid]="'editDistribution' + row.id"
            pTooltip="{{ 'common.edit' | translate }}" class="roundedButton row-buttom-margin"
            [ngClass]="{'disabled-button': row.flg_enabled === '1'}" [disabled]="row.flg_enabled === '1'"
            (click)="onOpenEdit(row)">
            <i class="pi pi-pencil icon-size"></i>
          </button>
          <button data-testid-generic="campaignActions" [attr.data-testid]="'campaignActions' + row.id"
            pTooltip="{{ 'common.actions' | translate }}" class="roundedButton row-buttom-margin"
            (click)="toggleMenu(row)">
            <i class="pi pi-ellipsis-h icon-size"></i>
          </button>

        </div>

        <div class="dropdown-menu" *ngIf="showMenu && row.id == currentOpenedRow">

          <button data-testid-generic="viewArticleList" [attr.data-testid]="'viewArticleList' + row.id"
            [disabled]="isButtonDisabled(row, 'viewArticles')" class="dropdown-item-creation"
            (click)="onViewArticlesList(row)" [ngClass]="{'notPermitted': isButtonDisabled(row, 'viewArticles')}">
            {{ 'baskets.view_articles_list' | translate }}
          </button>

          <button data-testid-generic="duplicateBasket" [attr.data-testid]="'duplicateBasket' + row.id"
            [disabled]="isButtonDisabled(row, 'duplicate')" class="dropdown-item-creation"
            (click)="onDuplicateBasket(row)" [ngClass]="{'notPermitted': isButtonDisabled(row, 'duplicate')}">
            {{ 'baskets.duplicate' | translate }}
          </button>

          <button data-testid-generic="addBasket" [attr.data-testid]="'addBasket' + row.id"
            [disabled]="isButtonDisabled(row, 'addProduct')" class="dropdown-item-creation"
            (click)="onAddProductToBasket(row)" [ngClass]="{'notPermitted': isButtonDisabled(row, 'addProduct')}">
            {{ 'baskets.add_product_to_basket' | translate }}
          </button>

          <button data-testid-generic="removeBasket" [attr.data-testid]="'removeBasket' + row.id"
            [disabled]="isButtonDisabled(row, 'removeProducts')" class="dropdown-item-creation"
            (click)="extractProductsByBasketAndOpenModal(row)"
            [ngClass]="{'notPermitted': isButtonDisabled(row, 'removeProducts')}">
            {{ 'baskets.remove_product_from_basket' | translate }}
          </button>

          <button data-testid-generic="viewActiveActions" [attr.data-testid]="'viewActiveActions' + row.id"
            class="dropdown-item-creation" *ngIf="isFeatureEnabled('ACTIVE_ACTIONS')"
            [disabled]="isButtonDisabled(row, 'viewActions')" (click)="onViewActiveActions(row)"
            [ngClass]="{ 'notPermitted': isButtonDisabled(row, 'viewActions') }">
            {{ 'baskets.view_active_actions' | translate }}
          </button>

          <button data-testid-generic="viewActivePromos" [attr.data-testid]="'viewActivePromos' + row.id"
            class="dropdown-item-creation" *ngIf="isFeatureEnabled('ACTIVE_PROMOS')"
            [disabled]="isButtonDisabled(row, 'viewPromos')" (click)="onViewActivePromos(row)"
            [ngClass]="{ 'notPermitted': isButtonDisabled(row, 'viewPromos') }">
            {{ 'baskets.view_active_promos' | translate }}
          </button>

          <button data-testid-generic="importFromCsv" [attr.data-testid]="'importFromCsv' + row.id"
            class="dropdown-item-creation" [disabled]="isButtonDisabled(row, 'importCsv')"
            (click)="onImportFromCsv(row)" [ngClass]="{ 'notPermitted': isButtonDisabled(row, 'importCsv') }">
            {{ 'baskets.import_from_csv' | translate }}
          </button>

          <button data-testid-generic="emptyBasket" [attr.data-testid]="'emptyBasket' + row.id"
            class="dropdown-item-creation" [disabled]="isButtonDisabled(row, 'emptyBasket')"
            (click)="onEmptyBasket(row)" [ngClass]="{ 'notPermitted': isButtonDisabled(row, 'emptyBasket') }">
            {{ 'baskets.empty_basket' | translate }}
          </button>

          <button data-testid-generic="deleteBasket" [attr.data-testid]="'deleteBasket' + row.id"
            class="dropdown-item-creation" [disabled]="isButtonDisabled(row, 'delete')" (click)="onDeleteBasket(row)"
            [ngClass]="{ 'notPermitted': isButtonDisabled(row, 'delete') }">
            {{ 'common.delete' | translate }}
          </button>

          <button data-testid-generic="recoverBasket" [attr.data-testid]="'recoverBasket' + row.id"
            class="dropdown-item-creation" [disabled]="isButtonDisabled(row, 'recover')" (click)="onRecoverBasket(row)"
            [ngClass]="{ 'notPermitted': isButtonDisabled(row, 'recover') }">
            {{ 'common.recover' | translate }}
          </button>

        </div>


      </ng-template>

    </app-campaign-3-kontable>
  </div>

</div>



<!-- selezione add articolo -->
<p-dialog *ngIf="show.modalPaniereAdd" [width]="1500" [height]="800" [(visible)]="show.modalPaniereAdd"
  [responsive]="true" [header]="'baskets.add_article' | translate " showEffect="fade" [modal]="true">

  <app-add-product-to-basket #addProductToBasket data-testid="addProductToBasket" [readOnly]="readOnly"
    (productsListCancel)="onStoresCancel()" [productsNotInSelectedBasket]="productsNotInSelectedBasket"
    (productsListSelected)="onProductsToAddSelected($event)"></app-add-product-to-basket>

</p-dialog>


<p-dialog *ngIf="show.modalDuplicateBasket" data-testid="duplicateBasketDialog" [width]="500" [height]="auto"
  [(visible)]="show.modalDuplicateBasket" [responsive]="true" [header]="'baskets.duplicate_basket' | translate"
  showEffect="fade" [modal]="true">

  <form class="duplicate-basket-form" data-testid="duplicateBasketForm" [formGroup]="duplicateBasketForm"
    (ngSubmit)="onSubmitDuplicateBasket()">

    <div class="p-fluid p-formgrid p-grid">

      <!-- Name -->
      <div class="p-field p-col-12 p-md-4">
        <label for="duplicateName">{{ 'baskets.name' | translate }}</label>
        <input id="duplicateName" type="text" pInputText formControlName="name"
          data-testid="duplicateBasketNameInput" />
        <small
          *ngIf="duplicateBasketForm.get('name') && duplicateBasketForm.get('name').invalid && duplicateBasketForm.get('name').touched"
          class="p-error" data-testid="duplicateBasketNameError">
          {{ 'baskets.name_required' | translate }}
        </small>
      </div>

      <!-- Code -->
      <div class="p-field p-col-12 p-md-4">
        <label for="duplicateCode">{{ 'baskets.code' | translate }}</label>
        <input id="duplicateCode" type="text" pInputText formControlName="code"
          data-testid="duplicateBasketCodeInput" />
        <small
          *ngIf="duplicateBasketForm.get('code') && duplicateBasketForm.get('code').invalid && duplicateBasketForm.get('code').touched"
          class="p-error" data-testid="duplicateBasketCodeError">
          {{ 'baskets.code_required' | translate }}
        </small>
      </div>

      <!-- Description -->
      <div class="p-field p-col-12 p-md-4">
        <label for="duplicateDescription">{{ 'baskets.description' | translate }}</label>
        <input id="duplicateDescription" type="text" pInputText formControlName="description"
          data-testid="duplicateBasketDescriptionInput" />
      </div>

    </div>

    <!-- Footer -->
    <div class="custom-footer">
      <button type="button" pButton data-testid="duplicateBasketCancelButton" label="{{ 'common.cancel' | translate }}"
        icon="pi pi-times" (click)="closeDuplicateBasketModal()">
      </button>

      <button type="submit" pButton data-testid="duplicateBasketConfirmButton"
        label="{{ 'common.confirm' | translate }}" icon="pi pi-check" [disabled]="duplicateBasketForm.invalid">
      </button>
    </div>
  </form>
</p-dialog>



<!-- selezione remove articolo -->
<p-dialog *ngIf="show.modalPaniereRemove" [width]="1500" [height]="800" [(visible)]="show.modalPaniereRemove"
  [responsive]="true" [header]="'baskets.remove_article' | translate " showEffect="fade" [modal]="true">
  <app-remove-product-from-basket #removeProductFromBasket data-testid="removeProductFromBasket"
    [productsListAlreadySelected]="productsListAlreadySelected" (productsListCancel)="onCloseProductToRemove()"
    (productsListSelected)="onProductsToRemoveSelected($event)"
    [rowSelected]="{identifierField: 'id', arrayValues: productsListAlreadySlected}"></app-remove-product-from-basket>

</p-dialog>


<p-dialog header="{{ 'campaign.confirm_delete' | translate }}" [(visible)]="displayBasketConfirmDialog" [modal]="true"
  [closable]="false" class="custom-dialog">

  <div>
    {{ basketConfirmMessage | translate }}
    <span *ngIf="basketSelected?.name">
      {{ basketSelected.name }}?
    </span>
  </div>

  <div class="custom-footer">
    <button type="button" data-testid="cancelDeleteBaketDialogButton" pButton label="{{ 'common.cancel' | translate }}"
      icon="pi pi-times" (click)="closeBasketConfirmDialog()">
    </button>

    <button type="button" data-testid="confirmDeleteBaketDialogButton" pButton
      label="{{ 'common.confirm' | translate }}" icon="pi pi-check" style="margin-left: .25em"
      (click)="onConfirmBasketAction()">
    </button>
  </div>
</p-dialog>


<p-dialog header="{{ 'baskets.confirm_recover' | translate }}" [(visible)]="displayRecoverBasketConfirmDialog"
  [modal]="true" [closable]="false" class="custom-dialog">

  <div>
    {{ basketConfirmMessage | translate }}
    <span *ngIf="basketSelected?.name">
      {{ basketSelected.name }}?
    </span>
  </div>

  <div class="custom-footer">
    <button type="button" data-testid="cancelRecoverBasketDialogButton" pButton
      label="{{ 'common.cancel' | translate }}" icon="pi pi-times" (click)="closeRecoverBasketConfirmDialog()">
    </button>

    <button type="button" data-testid="confirmRecoverBasketDialogButton" pButton
      label="{{ 'common.confirm' | translate }}" icon="pi pi-check" style="margin-left: .25em"
      (click)="onConfirmRecoverBasketAction()">
    </button>
  </div>
</p-dialog>



<footer>

</footer>


// WEBPACK FOOTER //
// ./src/app/views/baskets/baskets-list/basket-list.component.html